/* unplugin-vue-components disabled */import { render } from "./AddToCart.vue?vue&type=template&id=1a80edf0&scoped=true&ts=true"
import script from "./AddToCart.vue?vue&type=script&lang=ts"
export * from "./AddToCart.vue?vue&type=script&lang=ts"

import "./AddToCart.vue?vue&type=style&index=0&id=1a80edf0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a80edf0"]])

export default __exports__